import { createRequiredValidators } from "@xo/client-common";
import { Type13Code } from "./Type13Code";

export function createType13CodeValidators() {
    return [
        ...createRequiredValidators<Type13Code>(["code", "head1", "head2", "body1", "body2", "stringArray", "dateArray", "base", "baseArray"]),
    ];
}
